/*eslint-disable*/
import React from "react";
import Image from "next/image"
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import Camera from "@mui/icons-material/Camera";
import Palette from "@mui/icons-material/Palette";

// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import NavPills from "components/NavPills/NavPills.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Parallax from "components/Parallax/Parallax.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Button from "components/CustomButtons/Button.js";
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";

import styles from "pages-sections/services/ServicesSections.module.scss";

export default function ProfilePage({ ...rest }) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
  const navImageClasses = classNames(classes.imgRounded, classes.imgGallery);
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.png"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        title="Scott Sunderland - Tribalism"
        image="/img/examples/city-sm.webp"
        url="https://www.tribalism.com.au/about/profile-scott-sunderland"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. Meet Scott, Tribalism's Founder and Lead Consultant !"

        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color: "info",
        }}
      />

      <Parallax
        image="/img/examples/city-sm.webp"
        filter="dark"
        className={classes.parallax}
      />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem xs={12} sm={12} md={6}>
              <div className={classes.profile}>
                <div>
                  <img
                    src="/img/faces/scott-profile-sm.webp"
                    alt="..."
                    className={imageClasses}
                  />
                </div>
                <div className={classes.name}>
                  <h3 className={classes.title}>Scott Sunderland</h3>
                  <h6>FOUNDER/LEAD CONSULTANT</h6>
                  <a href=" https://twitter.com/ScottSunderl4nd" target="_blank">
                    <Button
                      justIcon
                      simple
                      color="twitter"
                      className={classes.margin5}
                    >
                      <i className={classes.socials + " fab fa-twitter"} />
                    </Button>
                  </a>
                  <a href="https://www.linkedin.com/in/scott-sunderland-86780641/" target="_blank">
                    <Button
                      justIcon
                      simple
                      color="linkedin"

                      className={classes.margin5}
                    >
                      <i className={classes.socials + " fab fa-linkedin"} />
                    </Button>
                  </a>

                  <a href="https://github.com/guruscott" target="_blank">
                    <Button
                      justIcon
                      simple
                      color="github"
                      className={classes.margin5}
                    >
                      <i className={classes.socials + " fab fa-github"} />
                    </Button>
                  </a>
                </div>
              </div>

            </GridItem>
          </GridContainer>
          <div className={classNames(classes.description, classes.textCenter)}>
            <p>
              Hi there! I'm Scott. I like sport. I like art. I like nerdy games like Blood on the clocktower.  I like nature. I like cities. I like exploring. 
              <br /><br /> 
              Ive got a lot of experience from various client situations in my 7/8 years of running Tribalism and prior to that too. Its given me an appreciation that not everyone thinks or understands things the same way I do. (Ive often learned this the hard way - but much less these days thankfully!) 
              <br /><br /> In terms of skills, I cover a lot of bases. I can build websites. I can code. I can build automations. Dashboards, satistical analysis, design, marketing - I'm strong in all of that. Ive run training sessions all over Australia and internationally on tools like Google Cloud Platform, Tag Manager, Google Ads and more.
              
                            <br /><br /> Thanks for reading! 😀
            </p>
          </div>
          <div className={classes.profileTabs}>
            <NavPills
              alignCenter
              color="primary"
              tabs={[
                {
                  tabButton: "Work",
                  tabIcon: Palette,
                  tabContent: (
                    <GridContainer>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={7}
                        className={classes.gridItem}
                      >
                        <h4 className={classes.title}>Latest Blog Posts</h4>
                        <GridContainer className={classes.collections}>

                          <GridItem xs={12} sm={12} md={6}>
                            <Card
                              raised
                              background
                              style={{ backgroundImage: "url('/img/posts/2023-12-13-ga4-custom-dimensions-in-looker-studio/bp202312-4.png')" }}
                            >
                              <CardBody background>
                                <h6 className={classes.category}>Analytics</h6>
                                <a href="/blog-post/2023/12/ga4-custom-dimensions-in-looker-studio">
                                  <h3 className={classes.cardTitle}>
                                    GA4 Custom Dimensions in Looker Studio
                                  </h3>
                                </a>
                                <Button round href="/blog-post/2023/12/ga4-custom-dimensions-in-looker-studio" color="info">
                                  <FormatAlignLeft className={classes.icons} /> Read article
                                </Button>
                              </CardBody>
                            </Card>
                          </GridItem>

                          <GridItem xs={12} sm={12} md={6}>
                            <Card
                              raised
                              background
                              style={{ backgroundImage: "url('/img/photo-gallery/mk-6.jpg')" }}
                            >
                              <CardBody background>
                                <h6 className={classes.category}>News</h6>
                                <a href="/blog-post/2022/07/tribalism-news-july-2022">
                                  <h3 className={classes.cardTitle}>
                                    Tribalism News July 2022
                                  </h3>
                                </a>
                                <Button round href="/blog-post/2022/07/tribalism-news-july-2022" color="success">
                                  <FormatAlignLeft className={classes.icons} /> Read article
                                </Button>
                              </CardBody>
                            </Card>
                          </GridItem>

                          <GridItem xs={12} sm={12} md={6}>
                            <Card
                              raised
                              background
                              style={{ backgroundImage: "url('/img/posts/2022-03-17-ga4-opinion/8.jpg')" }}
                            >
                              <CardBody background>
                                <h6 className={classes.category}>Analytics</h6>
                                <a href="/blog-post/2022/03/ga4-opinion">
                                  <h3 className={classes.cardTitle}>
                                    GA4 - Google Analytics (UA) Deprecation Date
                                  </h3>
                                </a>
                                <Button round href="/blog-post/2022/03/ga4-opinion" color="warning">
                                  <FormatAlignLeft className={classes.icons} /> Read article
                                </Button>
                              </CardBody>
                            </Card>
                          </GridItem>

                          <GridItem xs={12} sm={12} md={6}>
                            <Card
                              raised
                              background
                              style={{ backgroundImage: "url('/img/posts/2021-05-13-skitch/skitch-not-working-on-mac-resize.webp')" }}
                            >
                              <CardBody background>
                                <h6 className={classes.category}>Other</h6>
                                <a href="/blog-post/2021/05/skitch-not-working-on-our-mac">
                                  <h3 className={classes.cardTitle}>
                                    Skitch Not Working On Your Mac? (May 2021)
                                  </h3>
                                </a>

                                <Button round href="/blog-post/2021/05/skitch-not-working-on-our-mac" color="danger">
                                  <FormatAlignLeft className={classes.icons} /> Read article
                                </Button>
                              </CardBody>
                            </Card>

                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Card
                              raised
                              background
                              style={{ backgroundImage: "url('/img/posts/2020-10-01-FakeReviews/baliphotos20-min-resize.webp')" }}
                            >
                              <CardBody background>
                                <h6 className={classes.category}>Data</h6>
                                <a href="/blog-post/2020/10/the-fake-reviews-economy">
                                  <h3 className={classes.cardTitle}>
                                    The Fake Reviews Economy
                                  </h3>
                                </a>

                                <Button round href="/blog-post/2020/10/the-fake-reviews-economy" color="primary">
                                  <FormatAlignLeft className={classes.icons} /> Read article
                                </Button>
                              </CardBody>
                            </Card>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={6}>
                            <Card
                              raised
                              background
                              style={{ backgroundImage: "url('/img/posts/2020-07-15-Covid19/COVID-19_Map-resize.webp')" }}
                            >
                              <CardBody background>
                                <h6 className={classes.category}>Data</h6>
                                <a href="/blog-post/2020/07/covid-search-data">
                                  <h3 className={classes.cardTitle}>
                                    Covid-19 hotspots in Australia
                                  </h3>
                                </a>
                                <Button round href="/blog-post/2020/07/covid-search-data" color="warning">
                                  <FormatAlignLeft className={classes.icons} /> Read article
                                </Button>
                              </CardBody>
                            </Card>
                          </GridItem>
                        </GridContainer>
                      </GridItem>

                    </GridContainer>
                  ),
                },

                {
                  tabButton: "Media",
                  tabIcon: Camera,
                  tabContent: (
                    <GridContainer justifyContent="center">
                      <GridItem xs={12} sm={12} md={3}>
                        <div className={navImageClasses}>
                          <Image
                            layout="responsive"
                            quality={100}
                            width={255}
                            height={192}
                            alt="..."
                            src="/img/scott-photos/9-sm.webp"
                          />
                        </div>

                        <div className={navImageClasses}>
                          <Image
                            layout="responsive"
                            width={255}
                            height={340}
                            alt="..."
                            src="/img/scott-photos/5-sm.webp"

                          />
                        </div>


                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <div className={navImageClasses}>
                          <Image
                            layout="responsive"
                            quality={100}
                            width={255}
                            height={192}
                            alt="..."
                            src="/img/scott-photos/8-sm.webp"
                          />
                        </div>
                        <div className={navImageClasses}>
                          <Image
                            layout="responsive"
                            quality={100}
                            width={255}
                            height={192}
                            alt="..."
                            src="/img/scott-photos/6-sm.webp"

                          />
                        </div>

                        <div className={navImageClasses}>
                          <Image
                            layout="responsive"
                            width={255}
                            height={255}
                            alt="..."
                            src="/img/scott-photos/3-sm.webp"

                          />
                        </div>


                      </GridItem>
                    </GridContainer>
                  ),
                },
              ]}
            />
          </div>
          <Clearfix />
        </div>
      </div>
      <Footer

      />
    </div>
  );
}
